/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxButtonComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxbuttons';

/**
 * Button
 */
@Component({
    selector: 'ngc-button',
    template: `<jqxButton *ngIf="visible"
                [delay] = "delay"
                [disabled] = "disabled"
                [imgSrc] = "imgSrc"
                [imgWidth] = "imgWidth"
                [imgHeight] = "imgHeight"
                [imgPosition] = "imgPosition"
                [roundedCorners] = "roundedCorners"
                [rtl] = "rtl"
                [textPosition] = "textPosition"
                [textImageRelation] = "textImageRelation"
                [theme] = "theme"
                [template] = "template"
                [toggled] = "toggled"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxButton>`
})
export class NgcButtonComponent extends ControlComponent {
    @Input('delay') delay: any;
    @Input('imgSrc') imgSrc: any;
    @Input('imgWidth') imgWidth: any;
    @Input('imgHeight') imgHeight: any;
    @Input('imgPosition') imgPosition: any;
    @Input('roundedCorners') roundedCorners: any;
    @Input('rtl') rtl: any;
    @Input('textPosition') textPosition: any;
    @Input('textImageRelation') textImageRelation: any;
    @Input('theme') theme: any;
    @Input('template') template: any;
    @Input('toggled') toggled: any;
    @Input('value') value: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
}

/**
 * Button Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcButtonComponent],
    declarations: [NgcButtonComponent, jqxButtonComponent]
})
export class NgcButtonModule {
}